export default __webpack_public_path__ + "static/media/inv.13184d82.gif";